<template>
  <el-drawer v-model="drawer" :title="detail&&detail.status===0?'提现审核':'提现详情'" direction="rtl" :before-close="handleClose" size="800px">
    <template  #default>
      <el-descriptions v-if="detail"  border :column="2" size="small">
        <el-descriptions-item label="商家">
          <shop-box :detail="detail"></shop-box>
        </el-descriptions-item>
        <el-descriptions-item label="提现编号">{{detail.code}}</el-descriptions-item>
        <el-descriptions-item label="提现金额">￥{{detail.money}}</el-descriptions-item>
        <el-descriptions-item label="手续费">￥{{detail.commissionMoney}}</el-descriptions-item>
        <el-descriptions-item label="实际到账">￥{{detail.actualMoney}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{['待审核','成功','失败'][detail.status]}}</el-descriptions-item>
        <el-descriptions-item label="提现时间">{{detail.createTime}}</el-descriptions-item>
        <el-descriptions-item v-if="detail.errorMsg" label="备注">{{detail.errorMsg}}</el-descriptions-item>
      </el-descriptions>
      <h3>收款信息</h3>
      <el-descriptions v-if="detail"  border :column="2">
        <el-descriptions-item label="收款人">{{detail.userName}}</el-descriptions-item>
        <el-descriptions-item label="开户银行">{{detail.typeDesc}}</el-descriptions-item>
        <el-descriptions-item label="开户支行">{{detail.bankName}}</el-descriptions-item>
        <el-descriptions-item label="银行账号">{{detail.bankCode}}</el-descriptions-item>
      </el-descriptions>

      <el-form v-if="detail&&detail.status===0" ref="auditForm"  :model="addRow" label-width="100px">
        <h3>提现审核</h3>
        <form-item-rule label="审核状态" prop="status">
          <el-radio-group  v-model="addRow.status" >
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </form-item-rule>
        <form-item-rule v-if="addRow.status===2" label="驳回原因" prop="errorMsg">
          <el-input type="textarea" :rows="4" placeholder="请输入驳回原因" v-model="addRow.errorMsg" ></el-input>
        </form-item-rule>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="handleClose">关闭</el-button>
      <el-button v-if="detail&&detail.status===0" type="primary" @click="doAudit('auditForm')">保存</el-button>
    </template>
  </el-drawer>
</template>

<script>

import FormItemRule from "@/components/el/form-item-rule.vue";
import TButton from "@/components/el/t-button.vue";
import ShopBox from "@view/components/shop/shop-box.vue";

export default {
  name: "withdraw-detail-drawer",
  components: {ShopBox, TButton, FormItemRule},
  data() {
    return {
      drawer:false,
      detail:null,
      addRow:{id:"",status:1,errorMsg:""},
    }
  },
  mixins: [tableBase],
  methods: {
    handleClose(){
      this.drawer = false;
      this.detail = null;
    },
    open(row){
      this.detail = this.copyObj(row);
      this.drawer = true;
    },
    doAudit(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addRow.id = this.detail.id;
          this.simplePost("/api/business/shop/income/audit",this.addRow,res=>{
            this.drawer =false;
            this.$emit('load');
          });
        }
      })
    }
  },
  mounted() {

  }
}
</script>
<style lang="less" scoped>
</style>

